import { useState, useEffect, useCallback } from "react";
import Grid from "../components/grid";
import Container from "../components/basicComponents/container";
import {
  getProjectById,
  removeProject,
} from "../state-management/actions/project-actions";
import { useDispatch, useSelector } from "react-redux";
import { selectGlobalState } from "../state-management/selectors";
import {
  setAlert,
  setAlertSeverity,
  setAlertContext,
} from "../state-management/actions/alerts-actions";
import ProjectComponent from "../components/project";
import { ProjectDataProps } from "../types/public";
import {
  editProject,
  getProjects,
} from "../state-management/actions/project-actions";
import { setRowStatus } from "../state-management/actions/global-state-actions";
import moment from "moment-jalaali";
import { createNotificationData } from "../utils/createNotificationData";
import { addNotification } from "../state-management/actions/notification-actions";

export default function ProjectList() {
  const dispatch = useDispatch();
  const { departmentsData, currentUserData, groupingData } =
    useSelector(selectGlobalState);
  const [editFlag, setEditFlag] = useState(false);
  const initialData = {
    title: "",
    department_id: "",
    content: "",
    created_by: currentUserData._id,
    index_picture: "",
    index_video: "",
    tags: "",
    description: "",
    is_active: false,
    start_date: undefined,
  };

  const [formData, setFormData] = useState<ProjectDataProps>(initialData);
  const [projectsData, setProjectsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const permissionDepartment = groupingData.find(
    (item: any) => item.user_id === currentUserData._id
  )?.department_id || ["none"];

  const fetchData = useCallback(async () => {
    try {
      const response = await getProjects()(dispatch);
      const filterData = response.data.filter((item: any) =>
        permissionDepartment.includes(item.department_id)
      );
      setProjectsData(filterData);
    } catch (error) {
      console.log(error);
    }
  }, [dispatch]);

  useEffect(() => {
    dispatch(setRowStatus("clear id", false));
    fetchData();
  }, []);

  const columns: any = [
    { headerName: "عنوان پروژه", field: "title" },
    {
      headerName: "دسته بندی",
      valueGetter: (params: any) =>
        departmentsData.find(
          (dep: any) => dep._id === params.data.department_id
        )?.name || "",
    },
    { headerName: "انتشار", field: "is_active" },
  ];

  const handleEditSubmit = async (e: any) => {
    e.preventDefault();
    const { _id, ...cleanData } = formData;
    try {
      const theData = {
        ...cleanData,
        tags:
          typeof formData.tags === "string"
            ? formData?.tags.split("،").map((tag: string) => tag.trim())
            : [],
      };
      setLoading(true);
      const response = await editProject(_id, theData)(dispatch);
      if (response.status === 200) {
        setProjectsData((prev: any) =>
          prev.map((proj: any) =>
            proj._id === _id ? { ...proj, ...cleanData } : proj
          )
        );
        setLoading(false);
        dispatch(setRowStatus("clear id", false));
      }
      dispatch(setAlert(true));
      dispatch(setAlertSeverity("success"));
      dispatch(setAlertContext("ویرایش پروژه با موفقیت صورت پذیرفت"));
      setFormData(initialData);
      setEditFlag(false);
      const notificationData = createNotificationData({
        data: theData,
        departmentsData,
        currentUserData,
        groupingData,
        type: "edit",
        subject: "پروژه",
      });
      await addNotification(notificationData)(dispatch);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async (id: string) => {
    try {
      await removeProject(id)(dispatch);
      setProjectsData(projectsData.filter((proj: any) => proj._id !== id));
      dispatch(setAlert(true));
      dispatch(setAlertSeverity("success"));
      dispatch(setAlertContext(" حذف پروژه با موفقیت صورت پذیرفت"));
      const notificationData = createNotificationData({
        data: projectsData.find((item: any) => item._id === id),
        departmentsData,
        currentUserData,
        groupingData,
        type: "delete",
        subject: "پروژه",
      });
      await addNotification(notificationData)(dispatch);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleSetEditData = async (clear: boolean, id: any) => {
    setEditFlag(clear ? false : true);
    try {
      const response = await getProjectById(id)(dispatch);
      if (response.data && !clear) {
        setFormData({
          ...response.data,
          start_date: response.data.start_date
            ? moment(response.data.start_date)
            : undefined,
          _id: id,
        });
      }
      if (clear) {
        setFormData(initialData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="flex flex-col items-center w-full">
      <Container header="لیست پروژه">
        <Grid
          height={700}
          columns={columns}
          userData={projectsData}
          pageSize={20}
          editable={false}
          deleteBtn={true}
          editBtn={true}
          publishBtn={false}
          pagination={true}
          btnHeader="عملیات"
          handleDelete={handleDelete}
          handleSetData={handleSetEditData}
        />
      </Container>
      <div
        className="flex flex-col items-center w-full"
        style={{ display: editFlag ? "block" : "none" }}
      >
        <Container header="ویرایش">
          <ProjectComponent
            handleSubmit={handleEditSubmit}
            formData={formData}
            setFormData={setFormData}
            currentUserId={currentUserData._id}
            loading={loading}
          />
        </Container>
      </div>
    </div>
  );
}
